// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import zutil from 'zutil';
import hopt from 'hola_opt';
import config from 'pub_config';

const {cdn_url} = config;

export const get_sources = key=>{
    return zutil.get(hopt, `www_hola.animation.${key}`, [])
        .map(obj=>({...obj, src: `${cdn_url}${obj.src}`}))
        .map((obj, i)=>React.createElement('source', {key: i, ...obj}));
};
